export const moreHorizontal = (props) => {
  return (
    <svg
      width='28'
      height='28'
      viewBox='0 0 28 28'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M8.5 14C8.5 15.3807 7.38071 16.5 6 16.5C4.61929 16.5 3.5 15.3807 3.5 14C3.5 12.6193 4.61929 11.5 6 11.5C7.38071 11.5 8.5 12.6193 8.5 14Z'
        fill='#023F80'
      />
      <path
        d='M16.5 14C16.5 15.3807 15.3807 16.5 14 16.5C12.6193 16.5 11.5 15.3807 11.5 14C11.5 12.6193 12.6193 11.5 14 11.5C15.3807 11.5 16.5 12.6193 16.5 14Z'
        fill='#023F80'
      />
      <path
        d='M22 16.5C23.3807 16.5 24.5 15.3807 24.5 14C24.5 12.6193 23.3807 11.5 22 11.5C20.6193 11.5 19.5 12.6193 19.5 14C19.5 15.3807 20.6193 16.5 22 16.5Z'
        fill='#023F80'
      />
    </svg>
  );
};

export const moreVertical = (props) => {
  return (
    <svg
      width='28'
      height='28'
      viewBox='0 0 28 28'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M16.25 7C16.25 8.24264 15.2426 9.25 14 9.25C12.7574 9.25 11.75 8.24264 11.75 7C11.75 5.75736 12.7574 4.75 14 4.75C15.2426 4.75 16.25 5.75736 16.25 7ZM16.25 14C16.25 15.2426 15.2426 16.25 14 16.25C12.7574 16.25 11.75 15.2426 11.75 14C11.75 12.7574 12.7574 11.75 14 11.75C15.2426 11.75 16.25 12.7574 16.25 14ZM16.25 21C16.25 22.2426 15.2426 23.25 14 23.25C12.7574 23.25 11.75 22.2426 11.75 21C11.75 19.7574 12.7574 18.75 14 18.75C15.2426 18.75 16.25 19.7574 16.25 21Z'
        fill='#023F80'
      />
    </svg>
  );
};
